import React from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './Accordion';
import { Check } from 'lucide-react';
const tomosData = [{
  id: 'tomo-1',
  number: '1',
  title: 'Organización y Método de Estudio',
  icon: '📅',
  quote: 'Sin un sistema de organización, la carrera te pasa por encima.',
  items: ['Planificador semanal con bloques por materia', 'Plan de estudio semestral completo', 'Registro de lecturas obligatorias y optativas', 'Tracker de avance semanal', 'Sistema Cornell para tomar apuntes en clase', 'Hoja de seguimiento de hábitos académicos']
}, {
  id: 'tomo-2',
  number: '2',
  title: 'Psicoanálisis y Corrientes Clásicas',
  icon: '🛋️',
  quote: 'Freud, Lacan, Klein: entendelos de una vez y para siempre.',
  items: ['Resumen de los conceptos fundamentales del psicoanálisis freudiano', 'Introducción al estructuralismo lacaniano', 'Aportes de Melanie Klein y la escuela inglesa', 'Mapa conceptual comparativo de corrientes', 'Línea de tiempo histórica del psicoanálisis', 'Glosario de términos psicoanalíticos esenciales']
}, {
  id: 'tomo-3',
  number: '3',
  title: 'Psicología Cognitivo-Conductual',
  icon: '🔁',
  quote: 'La corriente más pedida en clínica. Acá la entendés de verdad.',
  items: ['Fundamentos del conductismo clásico y operante', 'Bases de la terapia cognitivo-conductual (TCC)', 'Reestructuración cognitiva: paso a paso', 'Principales técnicas de intervención conductual', 'Comparativa TCC vs. psicoanálisis', 'Casos clínicos breves con análisis TCC']
}, {
  id: 'tomo-4',
  number: '4',
  title: 'Psicopatología y Diagnóstico',
  icon: '🧩',
  quote: 'Entender los cuadros clínicos antes de enfrentarlos en la práctica.',
  items: ['Introducción al DSM-5 y CIE-11: diferencias y usos', 'Principales trastornos del eje I con criterios diagnósticos', 'Trastornos de personalidad: resumen y clasificación', 'Cuadros de ansiedad, depresión y espectro psicótico', 'Psicopatología del desarrollo: niñez y adolescencia', 'Esquema visual de diagnóstico diferencial']
}, {
  id: 'tomo-5',
  number: '5',
  title: 'Clínica y Primera Entrevista',
  icon: '🏥',
  quote: 'El tomo que te prepara para lo que ningún teórico te enseña.',
  items: ['Estructura de la primera entrevista clínica', 'Preguntas clave para la anamnesis', 'Cómo elaborar el motivo de consulta', 'Manejo del encuadre y el vínculo terapéutico', 'Plantilla de informe psicológico lista para usar', 'Errores frecuentes del principiante en clínica']
}, {
  id: 'tomo-6',
  number: '6',
  title: 'Recursos Visuales y Mapas Conceptuales',
  icon: '🗺️',
  quote: 'Lo que leíste en 200 páginas, resumido en una sola hoja.',
  items: ['Mapa conceptual de Trastornos de Ansiedad', 'Esquema comparativo de las principales corrientes', 'Línea de tiempo de la historia de la psicología', 'Árbol de teorías del desarrollo (Piaget, Vygotsky, Erikson)', 'Cuadro sinóptico de técnicas terapéuticas', 'Mapa de psicopatología del adulto']
}];
export function Tomos() {
  const accordionItems = tomosData.map(tomo => ({
    id: tomo.id,
    title: <div className="flex items-center gap-3" data-id="element-237">
        <span className="text-brand-lilac font-bold text-lg w-5" data-id="element-238">
          {tomo.number}
        </span>
        <span className="text-white font-semibold flex-1" data-id="element-239">{tomo.title}</span>
        <span className="text-xl" data-id="element-240">{tomo.icon}</span>
      </div>,
    content: <div className="pt-2" data-id="element-241">
        <p className="text-gray-300 italic mb-4 text-sm" data-id="element-242">"{tomo.quote}"</p>
        <ul className="space-y-2" data-id="element-243">
          {tomo.items.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-244">
              <Check className="w-4 h-4 text-brand-sky mt-0.5 flex-shrink-0" data-id="element-245" />
              <span data-id="element-246">{item}</span>
            </li>)}
        </ul>
      </div>
  }));
  return <section id="tomos-section" className="bg-brand-dark py-16 px-4 sm:px-6 lg:px-8" data-id="element-247">
      <div className="max-w-2xl mx-auto" data-id="element-248">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-249">
          <span className="inline-block bg-white/10 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4 border border-white/10" data-id="element-250">
            📦 Sistema Completo
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-251">
            6 tomos. Todo lo que necesitás. Todo resuelto.
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-252">
            Del primer año a las prácticas clínicas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-253">
          <Accordion items={accordionItems} defaultOpenId="tomo-1" className="mb-8" itemClassName="bg-white/5" data-id="element-254" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-darker rounded-xl p-6 border border-white/10" data-id="element-255">
          <h3 className="text-white font-bold mb-4" data-id="element-256">Cada tomo incluye:</h3>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-257">
            {['Contenido claro y estructurado', 'Lenguaje accesible sin perder rigor académico', 'Esquemas y tablas visuales', 'Alineado con planes de estudio argentinos 2026', '100% pensado para estudiantes de Psicología'].map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-258">
                <Check className="w-4 h-4 text-brand-violet mt-0.5 flex-shrink-0" data-id="element-259" />
                <span data-id="element-260">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}